<div class="not-found-container">
	<h1 i18n="@@404PageNotFound">404 - Page Not Found</h1>
	<p i18n="@@couldNotFindThePage">We could not find the page you were looking for.</p>
	<i class="far fa-sad-tear fa-8x mt-2" aria-hidden="true"></i>
	<a [routerLink]="['/']" class="mt-2 ui-button ui-widget ui-state-default ui-corner-all ui-button-text-only">
		<span class="ui-button-text ui-clickable" i18n="@@goToHomepage">Go To Homepage</span>
	</a>
</div>